import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowRight, Activity } from "lucide-react";
import { PageHeader } from "../components/PageHeader";
import { THERAPIES } from "../data/siteData";

const fadeUp = {
  initial: { opacity: 0, y: 24 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-60px" },
  transition: { duration: 0.55 },
};

const TherapeuticAreas = () => (
  <div data-testid="therapies-page">
    <PageHeader
      testId="therapies-header"
      eyebrow="Therapeutic Areas"
      title="From oncology specialisation to whole-family care"
      subtitle="What began as Eastern India's first branded oncology molecule house now spans seven therapeutic areas — each held to the same uncompromising standard."
    />

    <section className="mx-auto max-w-7xl px-4 py-20 sm:px-6 lg:px-8" data-testid="therapies-grid-section">
      <div className="grid gap-6 md:grid-cols-2">
        {THERAPIES.map((t, i) => (
          <motion.div
            key={t.name}
            {...fadeUp}
            transition={{ duration: 0.5, delay: (i % 2) * 0.08 }}
            className="rounded-2xl border border-slate-200 bg-white p-8 shadow-sm transition-shadow duration-300 hover:shadow-xl"
            data-testid={`therapy-detail-${i}`}
          >
            <div className="flex items-center gap-3">
              <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-blue-50 text-[#1D4ED8]">
                <Activity size={20} />
              </div>
              <h2 className="text-xl font-bold text-slate-900">{t.name}</h2>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-slate-600">{t.focus}</p>
            <div className="mt-5 rounded-xl bg-[#F2F7FB] px-4 py-3">
              <p className="font-mono text-[10px] font-semibold uppercase tracking-[0.2em] text-[#1D4ED8]">Key Brands</p>
              <p className="mt-1 text-xs font-medium leading-relaxed text-slate-700">{t.molecules}</p>
            </div>
          </motion.div>
        ))}
      </div>

      <motion.div {...fadeUp} className="mt-16 text-center">
        <Link
          to="/products"
          data-testid="therapies-browse-products-button"
          className="inline-flex items-center gap-2 rounded-full bg-[#1D4ED8] px-7 py-3.5 text-sm font-semibold text-white transition-colors duration-200 hover:bg-[#173CAE]"
        >
          Browse our medicines <ArrowRight size={16} />
        </Link>
      </motion.div>
    </section>
  </div>
);

export default TherapeuticAreas;
